// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"6202":"f8484318","6554":"f8484318"}[chunkId] + ".chunk.css";
};